export default __webpack_public_path__ + "images/8V.27b6cba.png";